const discountRoot = document.getElementById("discount-code-field");

if (discountRoot) {
    const input = discountRoot.querySelector("#id_discount_code");
    const applyBtn = discountRoot.querySelector("#discount-apply-btn");
    const removeBtn = discountRoot.querySelector("#discount-remove-btn");
    const msg = discountRoot.querySelector("#discount-message");

    if (input && applyBtn && removeBtn && msg) {
        const emptyMessage = discountRoot.dataset.emptyMessage || "";
        const failMessage = discountRoot.dataset.failMessage || "";
        const validateUrl = discountRoot.dataset.validateUrl || "";
        const courseScheduleId = discountRoot.dataset.courseScheduleId || "";

        const getCSRF = () => {
            const el = document.querySelector(
                'input[name="csrfmiddlewaretoken"]',
            );
            return el ? el.value : "";
        };

        const setMessage = (text, type) => {
            msg.textContent = text || "";
            msg.className = `mt-1 text-sm ${
                type === "success"
                    ? "text-green-600"
                    : type === "error"
                      ? "text-red-600"
                      : "text-gray-700"
            }`;
        };

        const toggleButtons = (applied) => {
            applyBtn.classList.toggle("hidden", applied);
            removeBtn.classList.toggle("hidden", !applied);
        };

        const setDiscountState = (amount, applied) => {
            discountRoot.dataset.discountAmount = amount || "";
            discountRoot.dataset.discountApplied = applied ? "true" : "false";
            document.dispatchEvent(new CustomEvent("discount:changed"));
        };

        applyBtn.addEventListener("click", () => {
            const code = (input.value || "").trim();
            if (!code) {
                setMessage(emptyMessage, "error");
                return;
            }

            const body = new URLSearchParams({ code });
            if (courseScheduleId) {
                body.append("course_schedule", courseScheduleId);
            }

            fetch(validateUrl, {
                method: "POST",
                headers: {
                    "Content-Type":
                        "application/x-www-form-urlencoded; charset=UTF-8",
                    "X-CSRFToken": getCSRF(),
                },
                body,
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.success) {
                        setMessage(data.message, "success");
                        toggleButtons(true);
                        setDiscountState(data.amount, true);
                        return;
                    }
                    setMessage(data.message, "error");
                    toggleButtons(false);
                    setDiscountState("", false);
                })
                .catch(() => setMessage(failMessage, "error"));
        });

        removeBtn.addEventListener("click", () => {
            input.value = "";
            setMessage("", "");
            toggleButtons(false);
            setDiscountState("", false);
        });

        input.addEventListener("input", () => {
            if (!input.value.trim()) {
                setMessage("", "");
                toggleButtons(false);
                setDiscountState("", false);
            }
        });
    }
}
